export default {
  api_key: process.env.VUE_APP_GOOGLE_API_KEY
}
